import React from 'react';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import DeleteConfirmationModal from 'components/modals/DeleteConfirmationModal';
import useConfirmation from 'hooks/useConfirmation';
import IconButtonWithTooltip from './IconButtonWithTooltip';

const DeleteButton = ({deleteItem, id, size, type="Button", color}) => {
    const deleteConfirmation = useConfirmation(deleteItem);
    return (
        <>
            <DeleteConfirmationModal {...deleteConfirmation.modalProps} />
            <IconButtonWithTooltip translationId='button.delete' icon={faTrash} onClick={() => deleteConfirmation.requestConfirmation(id)} type={type} size={size} color={color}/>
        </>
    );
};

export default DeleteButton;
